<template>
  <div>
    <div class="my-3">
      <p v-if="grapesJSInstance !== null">
        The list below shows the data elements that can be brought in to your email campaign to personalize for each email recipient. Clicking Select will bring the data string (begins with #) on the line you clicked select. The email campaign will show (for example) #FirstName#. To see the actual name, review the previews in Inbox Forecaster Report, and/or send an email to the test seed list.
      </p>
      <p v-else>
        The list below shows the data elements that can be brought in to your email campaign to personalize for each email recipient. Clicking Copy will bring the data string (begins with #) on your clipboard. The email campaign will show (for example) #FirstName#. To see the actual name, review the previews in Inbox Forecaster Report, and/or send an email to the test seed list.
      </p>
    </div>
    <div
      v-if="sections.length && personalizationTags.length"
      class="my-3"
    >
      <ejs-grid
        :data-source="personalizationTags"
        :toolbar="toolbarOptions"
        :allow-paging="true"
        :allow-filtering="true"
        :page-settings="pageSettings"
        :filter-settings="filterOptions"
        :allow-sorting="true"
        clip-mode="EllipsisWithTooltip"
      >
        <e-columns>
          <e-column
            field=" "
            header-text=""
            width="70"
            :template="selectTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          />
          <!--<e-column
            field="id"
            header-text="ID"
            width="80"
            :allow-filtering="false"
          />-->
          <e-column
            field="section"
            header-text="Section"
          />
          <e-column
            field="type"
            header-text="Type"
          />
          <e-column
            field="name"
            header-text="Name"
          />
          <e-column
            field="value"
            header-text="Value"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { GridPlugin, Toolbar, Search, Page, Sort, Filter } from '@syncfusion/ej2-vue-grids'
import { createElement } from '@syncfusion/ej2-base'
import { TextBox } from '@syncfusion/ej2-inputs'
import GridSelect from './GridSelect'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'

Vue.use(GridPlugin)
MultiSelect.Inject(CheckBoxSelection)

export default {
  provide () {
    return {
      grid: [Toolbar, Search, Filter, Sort, Page],
      onClick: this.onSelect,
      getSections: () => this.sections
    }
  },
  data () {
    return {
      pageSettings: { pageCount: 5, pageSize: 10, pageSizes: ['10', '25', '50', '100'] },
      filterOptions: {
        type: 'Menu',
        mode: 'OnEnter',
        operators: {
          stringOperator: [
            { value: 'startsWith', text: 'Starts With' },
            { value: 'endsWith', text: 'Ends With' },
            { value: 'contains', text: 'Contains' },
            { value: 'equal', text: 'Equal' }
          ]
        }
      },
      filter: {
        type: 'CheckBox'
      },
      toolbarOptions: ['Search'],
      customFilter: {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            this.dropInstance = new TextBox({
              placeholder: 'Enter the value'
            })
            this.dropInstance.appendTo(flValInput)
            this.$helpers.setFilterId(this.dropInstance.element)
          },
          write: (args) => {
            if (args.filteredValue) {
              this.dropInstance.value = args.filteredValue
            }
          },
          read: (args) => {
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value,
              false
            )
          }
        }
      },
      selectTemplate () {
        return {
          template: {
            extends: GridSelect
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent',
      sections: 'getTagsSections',
      personalizationTags: 'getPersonalizationTags'
    })
  },
  mounted () {
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    if (this.sections && this.sections.length === 0) {
      const response = this.getTagsSections({ userEmail })
      response
        .then(({ success }) => {
          if (success) {
            this.data = success
            if (this.personalizationTags && this.personalizationTags.length === 0) {
              const response = this.getPersonalizationTags({ userEmail })
              response
                .then(({ success }) => {
                  if (success) {
                    this.data = success
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  methods: {
    ...mapActions([
      'getTagsSections',
      'getPersonalizationTags'
    ]),
    onSelect (tagValue) {
      // if the grapeJS Instance is null, then copying the text for drag n drop
      if (this.grapesJSInstance === null) {
        this.legacyCopyToClipboard(tagValue)
        this.dynamicContent.modalRef.closeDialog()
      } else {
        this.grapesJSInstance.InsertMoreOptData({
          action: 'InsertMoreOptData',
          type: 'tag',
          value: tagValue,
          moreoption: true
        })
        this.dynamicContent.modalRef.closeDialog()
      }
    },
    legacyCopyToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
      } catch (err) {
        console.error('Unable to copy to clipboard', err)
      }
      document.body.removeChild(textArea)
    },
    getArrayFilter (placeHolder, propertyName) {
      return {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            if (args.target.parentElement.children) {
              args.target.parentElement.children[0].style.display = 'none'
              args.target.parentElement.children[1].style.paddingTop = '0px'
            }
            this.dropInstance = new MultiSelect({
              dataSource: this[propertyName],
              fields: {
                text: 'name',
                value: 'id'
              },
              placeholder: placeHolder,
              popupHeight: '200px',
              mode: 'CheckBox'
            })
            this.dropInstance.value = this.dropInstance.value || []
            this.dropInstance.appendTo(flValInput)
          },
          write: (args) => {
            let arr = []
            if (
              args.parent.filterModule.actualPredicate
                .tags !== undefined
            ) {
              arr = args.parent.filterModule.actualPredicate.tags.map(
                (element) => element.value
              )
            }
            this.dropInstance.value = Array.isArray(args.filteredValue)
              ? args.filteredValue
              : arr
          },
          read: (args) => {
            args.fltrObj.filterSettings.columns = args.fltrObj.filterSettings.columns.filter(
              (x) => {
                console.log(x, args.column.field, this.dropInstance.value)
                return x.field !== args.column.field
              }
            )
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value
            )
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
